
import { Component, Inject } from 'vue-property-decorator';
import { Navigator, Service } from '@/domain/providers';
import type { Navigation } from 'zr-arch';
import Services from '@/infrastructure/service';
import Vue from 'vue';

@Component({})
export default class SilentCallBack extends Vue {
    @Inject(Service) services!: Services;
    @Inject(Navigator) navigator!: Navigation;

    async created(): Promise<void> {
        console.log('trying to renew the access_token');
        await this.services.授权.signinSilentCallback();
        console.log('finish to renew the access_token');
    }
}
